import { RedirectRequest } from '@azure/msal-browser';
import { APPLICATION_NAMESPACE, APPLICATION_ID } from './authConstants';
import CurrentUser from './currentUser';
import { b2cPolicies } from './policies';

export { b2cPolicies } from './policies';
// signInAuthProvider: static Msal instance
// getSignInAuthProvider: dynamic Msal instance based on the current Locale
// export { signInAuthProvider, getSignInAuthProvider } from './authProvider';
export { signInAuthProvider } from './msalReactAuthProvider';
export { default as getAccessToken } from './getAccessToken';
export { default as CurrentUser } from './currentUser';
export { default as WebsocketClient } from './websocketClient';

// https://learn.microsoft.com/en-us/azure/active-directory-b2c/language-customization?pivots=b2c-custom-policy
function getAzureLocaleCode() {
  const currentUser = CurrentUser.getInstance();
  const defaultLocaleCode = currentUser.getLocale();
  const mapper = {
    'en-GB': 'en',
    zh: 'zh-hans',
    es: 'es',
  };
  return mapper[defaultLocaleCode] || 'en';
}

export const getLoginRequest = (defaultPage?: string): RedirectRequest => {
  return {
    redirectStartPage: defaultPage,
    scopes: [`https://${APPLICATION_NAMESPACE}.onmicrosoft.com/${APPLICATION_ID}/User.Read`],
    extraQueryParameters: { ui_locales: getAzureLocaleCode() },
  };
};

export const getPasswordForgetRequest = () => {
  return {
    ...b2cPolicies.authorities.customForgotPassword,
    extraQueryParameters: { ui_locales: getAzureLocaleCode() },
  };
};

export const getPasswordChangeRequest = () => {
  return {
    ...b2cPolicies.authorities.customPasswordChange,
    extraQueryParameters: { ui_locales: getAzureLocaleCode() },
  };
};

export const getEditProfileRequest = () => {
  return {
    ...b2cPolicies.authorities.customEditProfile,
    extraQueryParameters: { ui_locales: getAzureLocaleCode() },
  };
};
